import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	max-height: 400px;
	overflow: auto;
	margin-top: 1rem;
`;

export const AccordionContainer = styled.div`
	background: ${({ theme }) => theme.grayLight} !important;
	padding: 0.6rem 0 !important;
	margin: 0 0 1rem !important;
	border-radius: 4px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const AccordionTitle = styled.h5`
	font-weight: bold !important;
	margin: 0 0 5px 0 !important;
	padding: 0 16px !important;
`;

export const AccordionDetailsHistory = styled.div`
	display: flex;
	flex-direction: column;
	background: #fff !important;
	margin: 0 10px 0 10px;
	padding: 5px 5px !important;
`;

export const ContainerLabel = styled.div`
	display: flex;
	flex-direction: row;
`;

export const LabelItem = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	font-weight: bold;
	margin: 0 0.4rem;
`;

export const LabelResult = styled.div`
	color: ${({ theme }) => theme.pantoneBlack};
	word-break: break-all;
	div.kog-area-textToCopy {
		color: ${({ theme }) => theme.pantone2726C};
		max-width: none;
	}
`;

export const BoxLabelItem = styled.div`
	margin: 1rem 0;
`;

export const ColorBox = styled.div<{ color: string }>`
	background: transparent;
	height: 30px;
	width: 30px;
	cursor: pointer;
	position: relative;
	outline: none;
	border-radius: 50%;
	box-shadow: ${({ color }) => color} 0px 0px 0px 15px inset;
	transition: box-shadow 100ms;
`;

export const FileLink = styled.span`
	color: #3f5ec9;
	text-decoration: underline;
	cursor: pointer;
	display: inline-block;
	margin-bottom: 4px;
`;
